<template>
  <div class="table-page-wrapper">

    <div v-show="searchStatus" class="search-wrapper">
      <date-format-select @changeDateFormatData="changeDateFormatData($event.dateFormatId)"/>
      <search-channel-select v-model="tableParams.channelId" />
      <search-channel-slot-select v-model="tableParams.slotId" :channel-id="tableParams.channelId" />
      <search-dsp-select v-model="tableParams.dspId" :dspType="null" />
      <search-dsp-slot-select v-model="tableParams.dspSlotId" :dsp-id="tableParams.dspId" />
      <el-date-picker
        v-model="date"
        type="datetimerange"
        @change="changeDate"
        :shortcuts="shortcuts"
        :editable="false"
        unlink-panels
        style="width:270px;margin-right: 15px;"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期">
      </el-date-picker>
      <el-button @click="toQuery" type="primary" >搜索</el-button>
      <el-button
          @click="downExcel('/logBidReqInfo/get/log/bid/req/list/xlsx', '请求日记报表',downParam)"
          type="warning"

          style="margin-left: 10px"
          >下载
      </el-button>
    </div>

    <div class="table-wrapper">
      <table-column
        @search="searchColumn"
        @refresh="toQuery"
        @change="changeColumn"
        :column="columns"
        style="padding-bottom: 10px;">
      </table-column>

      <el-table
        v-loading="tableLoading"
        :data="tableData"
        height="80vh"
        :header-cell-style="{background:'#fafafa'}"
        highlight-current-row
        size="small"
        class="js-table"
        style="width: 100%">
          <el-table-column
            v-for="(v, i) in checkColumns"
            :prop="v.field"
            :label="v.title"
            :width="v.width"
            :sortable="v.field === 'timeHour'"
            :min-width="v.minWidth"
            :key="i"
            align="center">
            <template v-slot="scope">
              <div v-if="v.field=='reqBody'||v.field=='dspReqBody'">
              <el-popover
                placement="left"
                :width="1000"
                :show-after="200"
                trigger="click">
                <template #reference>
                  <span style="color: #409eff;cursor: pointer;">查看</span>
                </template>
                <pre>{{scope.row[v.field]?JSON.stringify(JSON.parse(scope.row[v.field]),null,'\t'):""}}</pre>
              </el-popover>
              </div>
              <span v-else>{{ scope.row[v.field] }}</span>
            </template>
          </el-table-column>
      </el-table>

      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :total="pagination.total"
        :pager-count="6"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :page-sizes="[10, 30, 60,100,200]"
        background
        layout="total,sizes,prev,pager,next"
        style="margin-top: 40px;" />
    </div>
  </div>
</template>

<script>
import DateFormatSelect from '@/components/DateFormatSelect'
import SearchChannelSelect from '@/components/SearchChannelSelect'
import SearchDspSlotSelect from '@/components/SearchDspSlotSelect'
import SearchDspSelect from '@/components/SearchDspSelect'
import SearchChannelSlotSelect from '@/components/SearchChannelSlotSelect'
import { formatDate, PURE_DATETIME_H_PATTERN } from '@/util/format'
import TableColumn from '@/components/TableColumn'
import { downExcelMixin } from '@/mixins/downExcel'

import initTableMixin from '@/mixins/initTable'

export default {
  name: 'diary',
  components: {
    DateFormatSelect,
    SearchChannelSelect,
    SearchDspSelect,
    SearchDspSlotSelect,
    SearchChannelSlotSelect,
    TableColumn
  },
  mixins: [initTableMixin, downExcelMixin],
  data () {
    return {
      columns: [
        { field: 'timeHour', title: '时间' },
        { field: 'channelName', title: '渠道名称' },
        { field: 'dspName', title: 'DSP名称' },
        { field: 'slotId', title: '广告位编号' },
        { field: 'slotName', title: '广告位名称' },
        { field: 'dspSlotName', title: 'DSP广告位名称' },
        { field: 'reason', title: '缺失参数' },
        { field: 'reqBody', title: '请求数据' },
        { field: 'dspReqBody', title: '请求DSP数据' }
      ],
      date: '',
      show: false,
      shortcuts: [
        {
          text: '今天',
          value: (() => {
            const end = new Date()
            const start = new Date()
            return [start, end]
          })()
        }, {
          text: '昨天',
          value: (() => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24)
            end.setTime(end.getTime() - 3600 * 1000 * 24)
            return [start, end]
          })()
        }, {
          text: '最近一周',
          value: (() => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 6)
            return [start, end]
          })()
        }
      ]
    }
  },
  computed: {
    downParam () {
      const params = Object.assign({}, this.pagination, this.tableParams)
      delete params.total
      params.hoursOrDays = 1
      return params
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.tableParams.hoursOrDays = 1
      this.date = [new Date(), new Date()]
      this.changeDate(this.date)
      this.init()
    })
  },
  methods: {
    beforeInit () {
      this.tableUrl = '/logBidReqInfo/get/log/bid/req/list'
      return true
    },
    changeDateFormatData (dateFormatId) {
      if (dateFormatId === 0) {
        this.tableParams.hoursOrDays = 1
      } else {
        this.tableParams.hoursOrDays = dateFormatId
      }
    },
    changeDate (date) {
      if (date) {
        this.tableParams.startTime = formatDate(date[0], PURE_DATETIME_H_PATTERN)
        this.tableParams.endTime = formatDate(date[1], PURE_DATETIME_H_PATTERN)
      }
    },
    // req(data){
    //   if(data){
    //   return JSON.stringify(JSON.parse(data),null,'\t')
    //   return `<div>
    //     <div>app</div>
    //     <div style="margin-left:20px">
    //       <p>bundle:${reqdata.app.bundle}</p>
    //       <p>id:${reqdata.app.id}</p>
    //       <p>name:${reqdata.app.name}</p>
    //       <p>ver:${reqdata.app.ver}</p>
    //     </div>
    //     <div>device</div>
    //     <div style="margin-left:20px">
    //       <p>caxxior:${reqdata.device.caxxior}</p>
    //       <p>connectiontype:${reqdata.device.connectiontype}</p>
    //       <p>devicetype:${reqdata.device.devicetype}</p>
    //       <p>did:${reqdata.device.did}</p>
    //       <p>didmd5:${reqdata.device.didmd5}</p>
    //       <p>dpid:${reqdata.device.dpid}</p>
    //       <p>dpidmd5:${reqdata.device.dpidmd5}</p>
    //     </div>
    //   </div>`
    //   }else{
    //     return ""
    //   }
    // },
    sortChange (column) {
      this.tableParams.asc = ''
      this.tableParams.desc = ''
      if (column.order === 'ascending') {
        this.tableParams.asc = column.prop
      } else {
        this.tableParams.desc = column.prop
      }
      this.init()
    }
  }
}
</script>

<style scoped lang="scss">
.search-wrapper{
  padding: 15px 15px 5px;
  margin-bottom: 10px;
  background: #ffffff;
  &>*{
    margin-right: 15px;
    margin-bottom: 10px;
    &:last-child{
      margin-right: 0;
    }
  }

  &>.el-select,&>.el-input{
    width: 220px;
  }
}

.table-wrapper{
  padding: 15px;
  background: #ffffff;
  .table__operation{
    padding-bottom: 10px;
  }
}

.el-pagination {
  text-align: right;
}
pre {
  white-space: pre-wrap;
  max-height: 500px;
  overflow-y: scroll;
  overflow-x: hidden;
}
</style>
